import { createContext, useContext } from "react";

const IntroStateContext = createContext(true);

export const IntroStateProvider = ({ introComplete, children }) => {
  return (
    <IntroStateContext.Provider value={introComplete}>
      {children}
    </IntroStateContext.Provider>
  );
};

export const useIntroComplete = () => useContext(IntroStateContext);
